import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  ContainerDivs,
  RetirementPlanGrid,
  RetirementPlanTable,
} from '../../components'
import Styles from './RetirementPlanGridTableWrap.css'


@CSSModules(Styles)
export default class RetirementPlanGridTableWrap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewAs: 0
    }
  }

  render() {
    return <div>
      <ContainerDivs>
        <div styleName='rplc-btn-wrap'>
          <h3 styleName='rplc-btn-label'>
            View as:
          </h3>
          <div>
            <button
              styleName='rplc-btn'
              onClick={()=>{ this.setState({viewAs:0}) }}
            >
              Logos
            </button>
            <button
              styleName='rplc-btn'
              onClick={()=>{ this.setState({viewAs:1}) }}
            >
              List
            </button>
          </div>
        </div>
      </ContainerDivs>
      {
        this.state.viewAs===0 ?
          <RetirementPlanGrid /> :
          <RetirementPlanTable />
      }
    </div>
  }
}